import * as actionType from "../constants/proyek";
import { apiCall } from "service/apiCall";
import { apiCall2 } from "service/apiCall2";
import { setLoading, setError, modalToggle, setLoadingTable } from "./general";
import Cookie from "universal-cookie";
import { get } from "lodash";
import { URL, URL_PARTNER, USER, PASS } from "service/base_url";
import moment from "moment";
import ExcelJS from "exceljs/dist/es5/exceljs.browser.js";
import { saveAs } from "file-saver";
import { loginToPartner, refreshToken, partnerRefreshToken } from "./auth";
import axios from "axios";
const cookie = new Cookie();
const token = cookie.get("login_cookie");
const token_partner = cookie.get("login_partner_cookie");
const profile = cookie.get("profile_cookie");

export const setProyek = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_PROYEK,
    payload: payload,
  });
};
export const resetHistoryCredit = (payload) => (dispatch) => {
  dispatch({
    type: actionType.RESET_HISTORY_CREDIT,
  });
};
export const setFilterSaProject = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_FILTER_SA_PROJECT,
    payload: payload,
  });
};
export const setFilterHistoryCredit = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_FILTER_HISTORY_CREDIT,
    payload: payload,
  });
};
export const setUseFilter = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_USE_FILTER,
    payload: payload,
  });
};
export const setEmailTemplate = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_EMAIL_TEMPLATE,
    payload: payload,
  });
};
export const setEmailBulk = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_EMAIL_BULK,
    payload: payload,
  });
};
export const setEmailBulkIndividual = (payload) => (dispatch) => {
  dispatch({
    type: actionType.SET_EMAIL_BULK_INDIVIDUAL,
    payload: payload,
  });
};
export const setCount = (payload) => (dispatch) => {
  // console.log('payload', payload)
  dispatch({
    type: actionType.SET_COUNT,
    payload: payload,
  });
};
export const resetProyek = (payload) => (dispatch) => {
  console.log("trigger");
  dispatch({
    type: actionType.RESET_PROYEK,
  });
};

export const postProyek = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/disc/admin/project",
    method: "POST",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(setProyek({ projectId: res.data.id }));
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Proyek berhasil ditambahkan",
        modal_component: "proyek",
        modal_size: 400,
        modal_type: "alert",
        modal_data: {
          msg: `<p>Proyek ${data.name} berhasil ditambahkan</p> `,
          ...res.data,
        },
        modal_action: "success",
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const putProyek = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/disc/admin/project",
    method: "PUT",
    data: { data: data, headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Proyek berhasil diedit",
        modal_component: "proyek",
        modal_size: 400,
        modal_type: "alert",
        modal_data: {
          msg: `<p>Proyek ${data.name} berhasil diedit</p> `,
          ...res.data,
        },
        modal_action: "success",
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};

export const uploadPeserta = (data, projectId) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: "/disc/admin/upload",
    method: "POST",
    data: {
      data: data,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Upload berhasil",
        modal_component: "proyek",
        modal_size: 400,
        modal_type: "alert",
        modal_data: {
          msg: `<p>Sejumlah peserta telah ditambahkan ke proyek</p> `,
          ...res.data,
        },
        modal_action: "success",
      }),
    );
    dispatch(getListUserProject(`/${projectId}/2/0/0/1/100/*`));
    dispatch(getDetailProjectProgress(projectId));

    return res;
  } else {
    dispatch(setLoading(false));
  }
};

export const getDashboard = () => async (dispatch) => {
  dispatch(setLoadingTable(true));
  let dataReq = {
    url: `/disc/admin/dashboard/${profile.id}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoadingTable(false));
    dispatch({
      type: actionType.SET_BERANDA,
      payload: res.data,
    });
    return res;
  } else {
    dispatch(setLoadingTable(false));
  }
};
export const getProject =
  (slug = `/${moment().format("MM")}/${moment().format("YYYY")}/1/10/*`) =>
  async (dispatch) => {
    dispatch(setLoadingTable(true));
    let dataReq = {
      url: `/disc/admin/listproject/${profile.id}${slug}`,
      method: "GET",
      data: { headers: { Authorization: `Bearer ${token}` } },
    };
    let res = await dispatch(apiCall(dataReq));
    if (get(res, "status") === 200) {
      dispatch(setLoadingTable(false));
      dispatch({
        type: actionType.GET_PROYEK,
        payload: {
          proyek: res.data.items,
          proyek_pagination: res.data.info,
        },
      });
      return res;
    } else {
      dispatch(setLoadingTable(false));
    }
  };
export const getDetailProjectProgress = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/disc/admin/detaildashboard/${id}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      setProyek({
        progress: {
          selesai: res.data.completed,
          proses: res.data.process,
          menunggu: res.data.waiting,
        },
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getDetailProject = (id) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/disc/admin/projectdetail/${id}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(setProyek({ projectId: res.data.project.id }));
    dispatch(setProyek({ nama: res.data.project.name }));
    dispatch(setProyek({ deskripsi: res.data.project.description }));
    dispatch(setProyek({ tgl_pengerjaan: res.data.project.startDate }));
    dispatch(setProyek({ periode: res.data.project.endDate }));
    dispatch(setProyek({ status: res.data.project.status }));
    dispatch(setProyek({ jenis_test: res.data.tests }));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};

export const getListUserProject = (slug) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/disc/admin/listuser2/${profile.id}${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      setProyek({
        peserta: {
          peserta_list: res.data.items,
          peserta_pagination: {
            page: res.data.info.page,
            perPage: res.data.info.perPage,
            total: res.data.info.total,
          },
        },
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getListTest = (slug) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/assess/list`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch({
      type: actionType.GET_LIST_TEST,
      payload: res.data,
    });
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getReport = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  let params = `projectId=${data.projectId}`;

  if (Array.isArray(data.userIds)) {
    data.userIds.forEach((userId) => {
      params += `&userIds=${userId}`;
    });
  } else {
    params += `&userIds=${data.userIds}`;
  }

  console.log("FINAL PARAMS", params);

  // const params = new URLSearchParams(data).toString();
  let dataReq = {
    url: `/BiofarmaSjtBod2/admin/report?${params}`,
    method: "GET",
    data: {
      data: data,
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    const contentDisposition = res.headers["content-disposition"];
    const contentType = res.headers["content-type"];
    let filename = "report.pdf";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      );
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    let mimeType = contentType || "application/pdf";

    const blob = new Blob([res.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    dispatch(setLoading(false));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};

export const getReportExcel = (data) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/BiofarmaSjtBod2/admin/export`,
    method: "POST",
    data: {
      data: { projectId: data.projectId, userIds: data.userIds },
      headers: { Authorization: `Bearer ${token}` },
    },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    const wb = new ExcelJS.Workbook();

    const sheet1 = wb.addWorksheet("Rekap Peserta", {
      views: [{ showGridLines: false }],
    });

    let borderStyles = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    const setCell = (cell, value, bold = true, align = "center") => {
      sheet1.getCell(cell).value = value;
      sheet1.getCell(cell).font = {
        name: "Calibri",
        family: 4,
        size: 12,
        bold,
      };
      sheet1.getCell(cell).alignment = {
        vertical: "middle",
        horizontal: align,
      };
    };

    const competencies = [
      {
        merge: "B1:E1",
        label: "Technology Savvy",
        prefix: "ts",
        colStart: "B",
      },
      { merge: "F1:I1", label: "Business Acumen", prefix: "ba", colStart: "F" },
      {
        merge: "J1:M1",
        label: "Customer Orientation",
        prefix: "co",
        colStart: "J",
      },
      { merge: "N1:Q1", label: "Collaborating", prefix: "cl", colStart: "N" },
      {
        merge: "R1:U1",
        label: "Planning & Organizing",
        prefix: "po",
        colStart: "R",
      },
      { merge: "V1:Y1", label: "Execution", prefix: "ex", colStart: "V" },
      { merge: "Z1:AC1", label: "Innovation", prefix: "in", colStart: "Z" },
      {
        merge: "AD1:AG1",
        label: "Continous Development",
        prefix: "cd",
        colStart: "AD",
      },
      {
        merge: "AH1:AK1",
        label: "Faciliting Change",
        prefix: "fc",
        colStart: "AH",
      },
      {
        merge: "AL1:AO1",
        label: "Valuing Difference",
        prefix: "vd",
        colStart: "AL",
      },
    ];

    const subHeaders = [
      "Case A skor (0/1/3/4)",
      "Case B Level (1-5)",
      "Final Score (Bobot 60:40)",
      "Gap Kompetensi",
    ];

    sheet1.mergeCells("A1:A2");
    setCell("A1", "Nama");

    competencies.forEach(({ merge, label }) => {
      sheet1.mergeCells(merge);
      setCell(merge.split(":")[0], label);
    });

    const colLetters = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "AA",
      "AB",
      "AC",
      "AD",
      "AE",
      "AF",
      "AG",
      "AH",
      "AI",
      "AJ",
      "AK",
      "AL",
      "AM",
      "AN",
      "AO",
    ];

    competencies.forEach(({ colStart }) => {
      const startIdx = colLetters.indexOf(colStart);
      subHeaders.forEach((sub, i) => {
        setCell(`${colLetters[startIdx + i]}2`, sub);
      });
    });

    sheet1.getColumn("A").width = 30;
    competencies.forEach(({ colStart }) => {
      const startIdx = colLetters.indexOf(colStart);
      [0, 1, 2, 3].forEach((i) => {
        sheet1.getColumn(colLetters[startIdx + i]).width = 22;
      });
    });

    res.data.forEach((user) => {
      const row = [user.nama];
      competencies.forEach(({ prefix }) => {
        row.push(user[`${prefix}A`] ?? "");
        row.push(user[`${prefix}B`] ?? "");
        row.push(user[`${prefix}Score`] ?? "");
        row.push(user[`${prefix}Gap`] ?? "");
      });
      sheet1.addRow(row);
    });

    sheet1.eachRow(function (row) {
      row.eachCell({ includeEmpty: true }, function (cell) {
        cell.border = borderStyles;
      });
    });

    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `Peserta.xlsx`);
    return res;
  } else {
    dispatch(setLoading(false));
  }
};

export const deletePesertaProyek = (slug) => async (dispatch) => {
  dispatch(setLoading(true));
  let dataReq = {
    url: `/disc/admin/assign2${slug}`,
    method: "DELETE",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Peserta berhasil dihapus",
        modal_component: "proyek",
        modal_size: 400,
        modal_type: "alert",
        modal_data: {
          msg: `<p></p> `,
          ...res.data,
        },
        modal_action: "success",
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getDetailForPartner = (slug) => async (dispatch) => {
  dispatch(setLoading(true));

  let dataReq = {
    url: `/disc/admin/integrasi${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));

    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const sendReportKominfo = (slug, name, tokens) => async (dispatch) => {
  let getDetail = await dispatch(getDetailForPartner(slug));
  if (getDetail) {
    dispatch(setLoading(true));

    let datasent = {
      url: `/profiling`,
      method: "POST",
      data: {
        data: getDetail.data,
        headers: { Authorization: `Bearer ${tokens}` },
      },
    };
    let sentToKominfo = await dispatch(apiCall2(datasent));
    if (get(sentToKominfo, "status") === 201) {
      dispatch(setLoading(false));
      // dispatch(modalToggle({
      //     modal_open: true,
      //     modal_title: "Data peserta berhasil dikirim",
      //     modal_component: "proyek",
      //     modal_size:400,
      //     modal_type:'alert',
      //     modal_data:{
      //         msg:`<p>Data <b>${name}</b> berhasil dikirim ke system Kominfo</p> `,
      //         ...sentToKominfo.data
      //     },
      //     modal_action:'success',
      // }))
      return sentToKominfo;
    } else {
      console.log("sentToKominfo", sentToKominfo.data);
      dispatch(
        modalToggle({
          modal_open: true,
          modal_title: "",
          modal_component: "",
          modal_size: 400,
          modal_type: "alert",
          modal_data: {
            msg: "<p>Opps, An error occurred,input field correctly or please contact Support team 🙏</p>",
          },
          modal_action: "error",
        }),
      );
      dispatch(setLoading(false));
    }
  }
};
export const getDataUserBatch = (slug) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/disc/admin/integrasi${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const updateDataSent = (slug) => async (dispatch) => {
  // dispatch(setLoading(true))

  let datasent = {
    url: `/disc/admin/sent${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 204) {
    // dispatch(setLoading(false))
    return res;
  } else {
    // dispatch(setLoading(false))
  }
};
export const sendReportKominfoAll = (data, tokens) => async (dispatch) => {
  // dispatch(setLoading(true))

  let datasent = {
    url: `/profiling`,
    method: "POST",
    data: { data: { ...data }, headers: { Authorization: `Bearer ${tokens}` } },
  };
  let sentToKominfo = await dispatch(apiCall2(datasent));
  if (get(sentToKominfo, "status") === 201) {
    // dispatch(setLoading(false))
    return sentToKominfo;
    // dispatch(modalToggle({
    //     modal_open: true,
    //     modal_title: "Data peserta berhasil dikirim",
    //     modal_component: "proyek",
    //     modal_size:400,
    //     modal_type:'alert',
    //     modal_data:{
    //         msg:`<p>Data <b>${name}</b> berhasil dikirim ke system Kominfo</p> `,
    //         ...sentToKominfo.data
    //     },
    //     modal_action:'success',
    // }))
  } else {
    console.log("eyoo", sentToKominfo.response.status);
    return sentToKominfo;

    // dispatch(setLoading(false))
  }
};

export const getEmailTemplate = (slug) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/assess/email${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(setEmailTemplate({ subject: res.data.subject }));
    dispatch(setEmailTemplate({ email: res.data.email }));
    dispatch(setProyek({ projectId: res.data.projectId }));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const postEmailTemplate = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/assess/email`,
    method: "POST",
    data: { headers: { Authorization: `Bearer ${token}` }, data: data },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    // dispatch(modalToggle({
    //     modal_open: true,
    //     modal_title: "Email Template",
    //     modal_component: "proyek",
    //     modal_size:400,
    //     modal_type:'alert',
    //     modal_data:{
    //         msg:`<p>Email template berhasil disimpan</p> `,
    //         ...res.data
    //     },
    //     modal_action:'success',
    // }))
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getEmailBulk = (slug) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/assess/bulk/email${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(setEmailBulk({ subject: res.data.subject }));
    dispatch(setEmailBulk({ email: res.data.email }));
    dispatch(setEmailBulk({ cc: res.data.cc }));
    dispatch(setEmailBulk({ userIds: res.data.cc }));
    dispatch(setProyek({ projectId: res.data.projectId }));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getEmailBulkIndividual = (slug) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/assess/individual/email${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(setEmailBulkIndividual({ subject: res.data.subject }));
    dispatch(setEmailBulkIndividual({ email: res.data.email }));
    dispatch(setEmailBulkIndividual({ cc: res.data.cc }));
    dispatch(setProyek({ projectId: res.data.projectId }));
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const postEmailBulk = (data) => async (dispatch) => {
  dispatch(setLoading(true));

  let datasent = {
    url: `/assess/report/email`,
    method: "POST",
    data: { headers: { Authorization: `Bearer ${token}` }, data: data },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoading(false));
    dispatch(
      modalToggle({
        modal_open: true,
        modal_title: "Email Template",
        modal_component: "proyek",
        modal_size: 400,
        modal_type: "alert",
        modal_data: {
          msg: `<p>Email template berhasil disimpan</p> `,
          ...res.data,
        },
        modal_action: "success",
      }),
    );
    return res;
  } else {
    dispatch(setLoading(false));
  }
};
export const getSaDashboard = () => async (dispatch) => {
  dispatch(setLoadingTable(true));
  let dataReq = {
    url: `/sa/dashboard`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(dataReq));
  if (get(res, "status") === 200) {
    dispatch(setLoadingTable(false));
    dispatch({
      type: actionType.SET_BERANDA_SA,
      payload: res.data,
    });
    return res;
  } else {
    dispatch(setLoadingTable(false));
  }
};
export const getSaListProject = (slug) => async (dispatch) => {
  dispatch(setLoadingTable(true));

  let datasent = {
    url: `/sa/project${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoadingTable(false));

    dispatch({
      type: actionType.GET_PROYEK,
      payload: {
        proyek: res.data.projects,
        proyek_pagination: res.data.info,
      },
    });
    return res;
  } else {
    dispatch(setLoadingTable(false));
  }
};
export const getListCredit = (clientId) => async (dispatch) => {
  dispatch(setLoadingTable(true));

  let datasent = {
    url: `/assess/credit/${clientId}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoadingTable(false));

    dispatch({
      type: actionType.GET_LIST_CREDIT,
      payload: res.data,
    });
    return res;
  } else {
    dispatch(setLoadingTable(false));
  }
};
export const getHistoryCredit = (slug) => async (dispatch) => {
  dispatch(setLoadingTable(true));

  let datasent = {
    url: `/assess/credit/history${slug}`,
    method: "GET",
    data: { headers: { Authorization: `Bearer ${token}` } },
  };
  let res = await dispatch(apiCall(datasent));
  if (get(res, "status") === 200) {
    dispatch(setLoadingTable(false));

    dispatch({
      type: actionType.GET_HISTORY_CREDIT,
      payload: {
        history_credit: res.data.items,
        history_credit_pagination: res.data.info,
      },
    });
    return res;
  } else {
    dispatch(setLoadingTable(false));
  }
};
